import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"

//#region Public Types

export const ALARM_CONTEXT_MENU_SERVICE_NAME = 'alarmContextMenuService'
export const ALARM_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'alarmContextMenuServiceProvider'

export type IdAlarmEventGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onConfirmAlarm?: (args: any) => void
}

//#endregion

export class AlarmContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdAlarmEventGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onConfirmAlarm != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARMS_CONFIRMATION_ENABLED)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit), ConfigHelper.Icon.ALARM_DONE, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onConfirmAlarm(e)
                }
            })
        }

        if (options.idReferenceTypes != null) {

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationModule)) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowLocations), ConfigHelper.Icon.LOCATIONS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdLocation, options.idReferenceTypes, Enums.ReferenceType.IdAlarmEvent)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdAlarmEvent)
                    },
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdAlarmEvent)
                    },
                })
            }
        }

        return items
    }

    // #endregion
}

export class AlarmContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new AlarmContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
